<style src="./Cbpf.scss" lang="scss" scoped></style>
<template>
  <section class="cbf">
    <content-header path="Cadastro / CBPF"/>
    
    <form v-on:submit.prevent="searchSubmit">
      <section class="form-box">
        <h4>Laboratório</h4>

        <suggest-lab
          label="Laboratório"
          placeholder="Busque o Laboratório"
          v-model="searchLab"
          @selected="selectedItem" />
      </section>

      <section
        v-if="showMaturityField"
        class="form-box">
        <h4>Validade do Certificado</h4>
        
        <datebox
          label="Data do evento"
          placeholder="05/01/2078"
          v-model="form.maturityDate" />
      </section>

      <section
        v-if="showFisicalForm"
        class="form-box">
        <h4>Forma Física</h4>
        
        <fisical-form-selector
          v-model="form.fisicalForm" />
      </section>

      <section
        v-if="showUploadDocument"
        class="form-box">
        <h4>Documento CBPF</h4>
        
        <form-file-input
          :lab="form.lab"
          :maturity-date="form.maturityDate"
          :fisicalForm="fisicalForm"
          @uploaded="uploaded" />
      </section>
    </form>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import { Textbox, SuggestLab, Datebox } from '@/components/primitives'
import FisicalFormSelector from './components/fisical-form-selector/FisicalFormSelector'
import FormFileInput from './components/form-file-input/FormFileInput'

export default {
  name: 'Cbpf',
  components: {
    ContentHeader,
    Textbox,
    Datebox,
    SuggestLab,
    FisicalFormSelector,
    FormFileInput
  },
  data () {
    return {
      searchLab: 'prat',
      form: {
        lab: '',
        maturityDate: '',
        fisicalForm: []
      }
    }
  },
  computed: {
    showMaturityField () {
      return this.form.lab.length > 0
    },
    showFisicalForm () {
      return this.form.maturityDate.length === 10
    },
    showUploadDocument () {
      return this.form.fisicalForm.length > 0
    },
    fisicalForm () {
      return this.form.fisicalForm.map(i => ({
        unityId: i.id,
        unityName: i.name
      }))
    }
  },
  methods: {
    selectedItem (item) {
      this.form.lab = item.source._id
    },
    uploaded () {
      this.form.fisicalForm = []
      this.form.lab = ''
      this.form.maturityDate = ''
      this.searchLab = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/cbpf/Cbpf.vue